import { Link } from 'react-router-dom';
import { MessageToolPage } from '@/components/seo/MessageToolPage';

export default function ApologyMessageGenerator() {
  return (
    <MessageToolPage
      title="Apology Message Generator — Free AI Sorry Tool"
      metaDescription="Generate a sincere apology message — free. Our AI helps you find the right words to say sorry to a partner, parent, friend, or family member."
      h1="Free Apology Message Generator"
      subtitle="Finding the right words for an apology is hard. Let AI help you say sorry — sincerely."
      toolLabel="Generate an Apology Message"
      placeholder="e.g. I said something hurtful during an argument and I want to make it right..."
      systemPrompt="Write a sincere, emotionally mature apology message. Acknowledge the specific harm, take responsibility without excuses, express genuine remorse, and commit to doing better. Tone should be humble, honest, and caring."
      faq={[
        { q: 'Can AI write a genuine apology?', a: 'AI helps you structure your feelings into a clear, sincere message. The emotions are yours — the AI just helps you organize them. Always personalize the result before sending.' },
        { q: 'What makes a good apology?', a: 'A good apology acknowledges the specific harm, takes responsibility, expresses empathy for how the other person felt, and commits to changed behavior. No "buts" or excuses.' },
        { q: 'Should I apologize in writing or in person?', a: 'Both are valid. Written apologies give you time to choose words carefully and give the recipient space to process. They can also be a powerful first step before an in-person conversation.' },
        { q: 'Is this tool free?', a: 'Yes. Generate apology messages at no cost. For a more beautiful, lasting format, create a free account on Say It NOW.' },
      ]}
      relatedPages={[
        { label: 'Apology Message Examples', href: '/apology-message-examples' },
        { label: 'Message to Someone You Love', href: '/message-to-someone-you-love' },
        { label: 'Heartfelt Message Generator', href: '/tools/heartfelt-message-generator' },
        { label: 'Thank You Message Generator', href: '/tools/thank-you-message-generator' },
      ]}
      seoContent={
        <>
          <h2>When Sorry Isn't Easy to Say</h2>
          <p>
            Apologizing is one of the most difficult things we do — not because the words are complicated, but because they require vulnerability. You have to admit you were wrong, face the discomfort of having hurt someone, and trust that your sincerity will be received.
          </p>
          <p>
            This free <strong>apology message generator</strong> helps you structure that vulnerability into clear, honest words. It doesn't replace your feelings — it gives them shape.
          </p>
          <h2>When a Written Apology Is Better</h2>
          <p>
            Sometimes emotions run too high for face-to-face conversation. A written apology lets you say exactly what you mean, without interruption or escalation. It also gives the other person time to read, process, and respond on their own terms.
          </p>
          <p>
            For more examples and guidance, visit our <Link to="/apology-message-examples">apology message examples</Link> page or <Link to="/signup">create a full Living Announcement</Link> to deliver your apology beautifully.
          </p>
        </>
      }
    />
  );
}
